/* RESPONSIBLE TEAM: team-standalone */
/* eslint-disable no-restricted-imports */
import {
  NEW_FRESHDESK_TICKET_TARGET,
  NEW_FRESHDESK_TICKET_TRIGGER,
  AT_CONVERSATION_START,
  TRIGGERABLE_BOT_TYPE,
  NON_VISITOR_ROLE_PREDICATE,
  WORKFLOWS_SETUP_TRIGGER_START_CONVERSATION,
} from 'embercom/lib/operator/custom-bots/constants';
import {
  matchBehaviors,
  objectTypes,
} from 'embercom/models/data/matching-system/matching-constants';
import NewFreshdeskTicketBotEditorConfig from 'embercom/objects/visual-builder/configuration/editor/new-freshdesk-ticket';

import CustomBotConfig from '../custom-bot';
import type { BotConfigTarget } from '../configuration';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

export default class NewFreshdeskTicketBotConfig extends CustomBotConfig {
  get rolePredicateGroup() {
    return { predicates: [NON_VISITOR_ROLE_PREDICATE] };
  }

  get target(): BotConfigTarget {
    return NEW_FRESHDESK_TICKET_TARGET;
  }

  get botType() {
    return TRIGGERABLE_BOT_TYPE;
  }

  get objectType() {
    return objectTypes.triggerableCustomBot;
  }

  get trigger() {
    return NEW_FRESHDESK_TICKET_TRIGGER;
  }

  get matchBehavior() {
    return matchBehaviors.transient;
  }

  get titleTranslationKey() {
    return 'operator.custom-bot.trigger.new-freshdesk-ticket.title';
  }

  get descriptionTranslationKey() {
    return 'operator.custom-bot.trigger.new-freshdesk-ticket.description';
  }

  get icon(): InterfaceIconName {
    return 'ticket';
  }

  get EditorConfigClass() {
    return NewFreshdeskTicketBotEditorConfig;
  }

  visibleToApp(app: any) {
    return app.canUseStandalone as boolean;
  }

  get selectableCustomBotType() {
    return true;
  }

  get requiredBillingFeature() {
    return 'bot_workflows';
  }

  get triggerContextType() {
    return AT_CONVERSATION_START;
  }

  get workflowsSetupTriggerType(): string[] {
    return [WORKFLOWS_SETUP_TRIGGER_START_CONVERSATION];
  }
}
